import { SELECIONAR_CONFIGURACAO_PONTO  } from '../types'

export default function selecionarAdesaoPonto (emissaoCteOs) {
  return {
    type: SELECIONAR_CONFIGURACAO_PONTO,
    payload: emissaoCteOs
  }
}
